import { render, staticRenderFns } from "./CustomerGeography.vue?vue&type=template&id=6ff130a4&scoped=true&"
import script from "./CustomerGeography.vue?vue&type=script&lang=js&"
export * from "./CustomerGeography.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGeography.vue?vue&type=style&index=0&id=6ff130a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff130a4",
  null
  
)

export default component.exports